import type { CSSProperties } from 'react';
import { useEffect, useState } from 'react';
import { vscodeTheme } from '../../styles/theme';
import {
  clearGitHubToken,
  getGitHubToken,
  isGitHubAuthenticated,
  loginWithGitHub,
} from '../../auth/github';

const buttonStyle: CSSProperties = {
  padding: '6px 10px',
  borderRadius: '4px',
  border: `1px solid ${vscodeTheme.colors.border}`,
  backgroundColor: vscodeTheme.colors.buttonBackground,
  color: vscodeTheme.colors.textPrimary,
  cursor: 'pointer',
  fontSize: '12px',
};

interface GitHubAuthProps {
  mode?: 'login-only' | 'status';
  returnTo?: string;
}

export function GitHubAuth({ mode = 'status', returnTo }: GitHubAuthProps) {
  const [isAuthenticated, setIsAuthenticated] = useState(isGitHubAuthenticated());
  const [authError, setAuthError] = useState<string | null>(null);

  useEffect(() => {
    const handleAuthChange = () => {
      setIsAuthenticated(isGitHubAuthenticated());
    };

    const handleAuthError = () => {
      setAuthError('GitHub認証が期限切れです。再ログインしてください。');
      setIsAuthenticated(false);
    };

    window.addEventListener('github-auth-change', handleAuthChange);
    window.addEventListener('github-auth-error', handleAuthError);

    return () => {
      window.removeEventListener('github-auth-change', handleAuthChange);
      window.removeEventListener('github-auth-error', handleAuthError);
    };
  }, []);

  const token = getGitHubToken();
  const tokenSummary = token ? `${token.slice(0, 6)}…` : '';

  if (mode === 'login-only' && isAuthenticated) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        marginBottom: '8px',
      }}
    >
      {authError && (
        <span style={{ color: vscodeTheme.colors.error, fontSize: '12px' }}>
          {authError}
        </span>
      )}
      {isAuthenticated && mode === 'status' ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '12px', color: vscodeTheme.colors.textSecondary }}>
            GitHub認証済み {tokenSummary}
          </span>
          <button
            type="button"
            style={buttonStyle}
            onClick={() => {
              clearGitHubToken();
              setAuthError(null);
            }}
          >
            ログアウト
          </button>
        </div>
      ) : (
        <button
          type="button"
          style={buttonStyle}
          onClick={() => loginWithGitHub(returnTo)}
        >
          GitHubでログイン
        </button>
      )}
    </div>
  );
}
